import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
// import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
// import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderAppExplore from '../../sections/header/HeaderAppExplore'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { UserPost } from '../../types/posts'
import AppUserPost from '../../components/app_userPost/AppUserPost'

import './style.scss';
import { CommunityData } from '../../server/types'
import AppPostButton from '../../components/app_postButton/AppPostButton'
import AppPost from '../../components/app_post/AppPost'
import { communityStateData } from '../../data/communityStateData'
import { postConnector } from '../../server/connector/postConnector'
import { communityConnector } from '../../server/connector/communityConnector'
import AppComment from '../../components/app_comment/AppComment'
import { setUserPosts } from '../../redux/reducers/postSlice'

function AppExplore() {
	const showNewPost = useAppSelector((state) => state.user.showNewPost)
	const commentPost = useAppSelector((state) => state.post.commentPost)
	const dispatch = useAppDispatch()
	// const communityProfiles: CommunitiesResultProfile[] = [
	// 	{
	// 		id: '1',
	// 		name: 'Community Name',
	// 		profile_pic: '/imgs/temp/community/temp-icon.png'
	// 	},{
	// 		id: '2',
	// 		name: 'Skiing Community',
	// 		profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
	// 	},{
	// 		id: '3',
	// 		name: 'Other Com',
	// 		profile_pic: '/imgs/temp/community/temp-comm_02.png'
	// 	},{
	// 		id: '4',
	// 		name: 'Example',
	// 		profile_pic: '/imgs/temp/community/temp-comm_03.jpg'
	// 	},{
	// 		id: '1',
	// 		name: 'Additional',
	// 		profile_pic: '/imgs/temp/community/temp-icon.png'
	// 	},{
	// 		id: '2',
	// 		name: 'New',
	// 		profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
	// 	}
	// ]
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)
	const [loadingPosts, setLoadingPosts] = useState<boolean>(false)

	// const [userPosts, setUserPosts] = useState<UserPost[]>([])
	const userPosts = useAppSelector(state => state.post.userPosts)
	const [userCommunities, setUserCommunities] = useState<CommunityData[]>([])
	const [showingExplore, setShowingExplore] = useState<boolean>(true)

	// const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			// makeInitialSearchRequest()
			getPageData()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	useEffect(() => {
		if (showNewPost === false) {
			// getPageData()
		}
	}, [showNewPost])

	// const makeInitialSearchRequest = () => {
	// 	instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
	// 		setFirstSearchLoaded(true)
	// 		dispatch(updateExploreProfiles())
	// 		if (!successRequest) {
	// 			console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
	// 		}
	// 	})
	// }

	const clickShowExploring = () => {
		getMainFeed()
		setShowingExplore(true)
	}

	const clickShowFeed = () => {
		getUserFeed()
		setShowingExplore(false)
	}

	const getPageData = () => {
		// postConnector.getUserPostsRequest(userStateData.getId()).then((successResponse) => {
		// getMainFeed()
		// setUserPosts(communityStateData.userPosts)

		communityStateData.userCommunities = []
		communityConnector.getCommunitiesForUserRequest(userStateData.getId()).then((successResponse) => {
			if (communityStateData.userCommunities.length > 0) {
				setUserCommunities(communityStateData.userCommunities)
			} else {
				// setUserCommunities()
				communityConnector.getAllCommunitiesRequest().then((successResponse) => {
					setUserCommunities(communityStateData.communities)
				})
			}
		})
		postConnector.getLikesForUserRequest(userStateData.getId()).then((likeIds: string[]) => {
			userStateData.likesPostIds = likeIds
			getMainFeed()
		})
	}

	const getMainFeed = () => {
		// setUserPosts([])
		dispatch(setUserPosts([]))
		setLoadingPosts(true)
		postConnector.getAllPostsRequest().then((successResponse) => {
			// setUserPosts(communityStateData.userPosts)
			dispatch(setUserPosts(communityStateData.userPosts))
			setFirstSearchLoaded(true)
			setLoadingPosts(false)
		})
	}

	const getUserFeed = () => {
		// setUserPosts([])
		dispatch(setUserPosts([]))
		setLoadingPosts(true)
		postConnector.getAllPostsForUserFeedRequest(userStateData.getId()).then((successResponse) => {
			// setUserPosts(communityStateData.userPosts)
			dispatch(setUserPosts(communityStateData.userPosts))
			setFirstSearchLoaded(true)
			setLoadingPosts(false)
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap'>
						<div className='section-content'>
							<HeaderAppExplore />
						</div>
					</div>
					<div className='app-explore-communities-reel-wrap'>
						{/* {communityStateData.communities.map((profile: CommunityData, index: number) =>  */}
						{userCommunities.map((profile: CommunityData, index: number) => 
							<div 
								className='app-explore-communities-reel-item'
								key={`commProfile${index}`}
								onClick={() => {
									// window.location.replace(`${PAGE_URLS.APP_COMMUNITY}?id=${index + 1}`)
									window.location.replace(`${PAGE_URLS.APP_COMMUNITY}?id=${profile.id}`)
								}}
							>
								<div className='app-explore-communities-reel-item-img'>
									<img 
										className='app-explore-communities-reel-item-img-inner'
										src={profile.community_icon_img}
										alt='Profile'
									/>
								</div>
								<div className='app-explore-communities-reel-item-label'>{profile.community_name.length > 9 ? `${profile.community_name.substring(0, 9)}...` : profile.community_name}</div>
							</div>
						)}
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space'>
						<div className='app-explore-top-section-wrap'>
							<div className='app-community-page-switch-wrap'>
								<button 
									className={`app-community-page-switch-button ${showingExplore === true ? 'app-community-page-switch-button-selected' : ''}`}
									onClick={() => {
										// setShowingExplore(true)
										clickShowExploring()
									}}
									disabled={loadingPosts}
								>
									<div
										className='app-community-page-switch-label'
									>Explore</div>
								</button>
								{/* <div className='app-community-page-switch-button'> */}
								<button 
									className={`app-community-page-switch-button ${showingExplore === false ? 'app-community-page-switch-button-selected' : ''}`}
									onClick={() => {
										// setShowingExplore(false)
										clickShowFeed()
									}}
									disabled={loadingPosts}
								>
									<div
										className='app-community-page-switch-label'
									>My Feed</div>
								</button>
							</div>
						</div>
						<div className='app-community-page-content-section-wrap'>
							{userPosts.length > 0 ?
								userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
								:
								<div className='app-community-page-content-section-empty-text'>
									Loading
								</div>
							}
							{/* {showingExplore ? 
								<>
									{userPosts.length > 0 ?
										userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
										:
										<div className='app-community-page-content-section-empty-text'>
											Loading
										</div>
									}
								</>
								:
								<div className='app-community-page-content-section-empty-text'>
									<div className='app-community-page-content-section-empty-text-title'>You haven't posted yet...</div>
									<div className='app-community-page-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
								</div>
							} */}
						</div>
					</div>
					<BackToTopButton />
				</>
			}
			<AppPostButton />
			<AppFooter activeIndex={0} />
			{showNewPost && <AppPost />}
			{commentPost && <AppComment postData={commentPost} />}
		</>
	)
}

export default AppExplore
